import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BASE_URL = process.env.REACT_APP_API_URL || "";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail]   = useState("");
  const [sent, setSent]     = useState(false);
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await fetch(`${BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      // Always show success — backend never reveals if email exists
      setSent(true);
    } catch {
      setError(t("forgotPassword.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
      <div style={{ textAlign: "center", maxWidth: 400, width: "100%" }}>
        {sent ? (
          <>
            <h2>✓ {t("forgotPassword.sentTitle")}</h2>
            <p>{t("forgotPassword.sentBody")}</p>
            <Link to="/login">{t("forgotPassword.backToLogin")}</Link>
          </>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <h2 className="auth-title">{t("forgotPassword.title")}</h2>
            <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "1rem" }}>
              {t("forgotPassword.instructions")}
            </p>
            {error && <p className="auth-error">{error}</p>}
            <input
              type="email"
              placeholder={t("forgotPassword.emailPlaceholder")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
            <div className="auth-actions">
              <button type="submit" disabled={loading}>
                {loading ? t("forgotPassword.sending") : t("forgotPassword.send")}
              </button>
              <Link to="/login" className="auth-cancel">{t("forgotPassword.backToLogin")}</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
